import { gql } from "@apollo/client";

export const CREATE_INITIATIVE = gql`
  mutation Mutation($data: InitiativeInputData!) {
    createInitiative(data: $data) {
      id
      serviceId
      name
      description
      address
      images
    }
  }
`;
